import { Button } from '@skylabs-digital/backoffice-kit';
import { Check, Copy, ShieldAlert } from 'lucide-react';
import { useState } from 'react';

interface Props {
  apiKey: string;
  onDismiss: () => void;
}

export function ApiKeyReveal({ apiKey, onDismiss }: Props) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(apiKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-3 rounded-lg border border-warning/40 bg-warning/10 p-4">
      <div className="flex items-start gap-3">
        <ShieldAlert className="mt-0.5 h-5 w-5 text-warning" />
        <div className="text-sm text-foreground">
          <p className="font-semibold">API key (shown once)</p>
          <p className="text-muted-foreground">
            Copy this secret now — it can't be retrieved later.
          </p>
        </div>
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <code className="flex-1 break-all rounded-md bg-background/80 px-3 py-2 font-mono text-sm">
          {apiKey}
        </code>
        <Button onClick={handleCopy} variant={copied ? 'secondary' : 'default'} size="sm">
          {copied ? <Check /> : <Copy />}
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </div>
      <div className="flex justify-end">
        <Button variant="ghost" size="sm" onClick={onDismiss}>
          I've saved it · Dismiss
        </Button>
      </div>
    </div>
  );
}
